import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRedeem$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRedeem extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0288e245bbbb9e9136994bc55b9600b3fb3694f5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ed7cffc2c80356557c0eb26828ab8a7b31c6e549', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b495af4880df0c6320a87731722adaf1b2c77c82', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 6h-2.13a2.17 2.17 0 0 0 .37-1.24 2.49 2.49 0 0 0-2.64-2.59 2.73 2.73 0 0 0-2.58 1.63l-.52 1-.55-1a2.81 2.81 0 0 0-2.56-1.63 2.49 2.49 0 0 0-2.64 2.59c-.003.443.13.875.38 1.24H3.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5m-4.4-2.33a1.11 1.11 0 0 1 1.14 1.21A1.14 1.14 0 0 1 14 6h-2l.77-1.47c.51-.83.96-.86 1.33-.86M6.75 4.88a1.11 1.11 0 0 1 1.14-1.21 1.32 1.32 0 0 1 1.25.82L9.93 6H8a1.14 1.14 0 0 1-1.25-1.12M17.5 16.5h-13v-2h13zm0-3.5h-13V7.5h5.09L8.52 9.55a.49.49 0 0 0 .21.67l.44.23a.5.5 0 0 0 .68-.21L11 8l1.15 2.2a.49.49 0 0 0 .67.21l.45-.23a.5.5 0 0 0 .21-.67L12.41 7.5h5.09z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-redeem", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-redeem"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-redeem":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRedeem$1);
            }
            break;
    } });
}

const CosmosIconRedeem = CosmosIconRedeem$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRedeem, defineCustomElement };
